<script>
import { formatarDataHoraPadraoBrasileiro } from "@/utils/DateUtils";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headersInfo: [
        {text: 'Data Evento', value: 'dataSolicitacao'},
        {text: 'Tipo', value: 'tipo'},
        {text: 'Início', value: 'horaInicio'},
        {text: 'Fim', value: 'horaFim'},
        {text: 'Decorrido', value: 'decorrido'},
        {text: 'Status', value: 'status'}
      ],
      headerHistorico: [
        {text: 'Data', value: 'dataAlteracao'},
        {text: 'Tipo', value: 'tipo'},
        {text: 'Quem', value: 'nomePessoaAlteradora'},
      ],
    };
  },
  methods: {
    formatDate(date) {
      return formatarDataHoraPadraoBrasileiro(date);
    }
  },
};
</script>

<template>
  <div>
    <h4>Histórico Horas Excedentes e Ausência</h4>
    <v-data-table class="pt-4" :headers="headersInfo" :items="[item.registro]" hide-default-footer>
      <template v-slot:item.dataSolicitacao="{ item }">
        {{ formatDate(item.dataSolicitacao) }}
      </template>
    </v-data-table>
    <v-row class="pt-4">
      <v-col cols="4" md="4">
        <h5>Solicitante</h5>
        <p>{{ item.registro.nomePessoaSolicitante }}</p>
      </v-col>
      <v-col cols="8" md="4">
        <h5>Descrição</h5>
        <p>{{ item.registro.descricao }}</p>
      </v-col>
    </v-row>
    <v-data-table :headers="headerHistorico" :items="item.dados" hide-default-footer>
      <template v-slot:item.dataAlteracao="{ item }">
        {{ formatDate(item.dataAlteracao) }}
      </template>
    </v-data-table>
  </div>
</template>